import React, {useState} from "react";
import ScrollToBottom from "react-scroll-to-bottom";
import styled from "styled-components";
import Messages from "./Messages";
import {LoadingView} from "../components/Loading";
import {MessageOfConversation} from "./types";

const Scroll = styled(ScrollToBottom)`
    height: 500px;

    &.hideInput {
        height: 500px;
    }

    &.showInput {
        height: 330px;
    }
`;

type Props = {
    conversation: any;
    messages: Array<MessageOfConversation>;
    lastIndex: number;
    dispatch: any;
    previousIndex: number;
    hasPreviousPage: boolean;
    init: boolean;
    showInput: boolean;
};

function ScrollToBottomMessages({
                                    messages,
                                    conversation,
                                    lastIndex,
                                    dispatch,
                                    previousIndex,
                                    hasPreviousPage,
                                    init,
                                    showInput
                                }: Props) {
    const [loading, setLoading] = useState(false);

    return (
        <>
            <Scroll mode={"bottom"} className={showInput ? 'showInput' : 'hideInput'}>
                {/*{loading && <LoadingView containerHeight={"32px"} imgHeight={"20px"} />}*/}
                {loading && hasPreviousPage && <LoadingView containerHeight={"32px"} imgHeight={"20px"}/>}
                <Messages
                    conversation={conversation}
                    messages={messages}
                    lastIndex={lastIndex}
                    dispatch={dispatch}
                    previousIndex={previousIndex}
                    hasPreviousPage={hasPreviousPage}
                    init={init}
                    loading={loading}
                    setLoading={setLoading}
                />
            </Scroll>
        </>
    );
}

export default ScrollToBottomMessages;
